import React from 'react';
import { Server } from '../../server/server';
import PageEnvelope from '../elements/PageEnvelope';
import './SitePage.css';
import { Navigate } from 'react-router-dom';

interface StatsPageState {
  balance: number;
  wru: number;
  rru: number;
  elapsed: number;
}

class StatsPage extends React.Component<{} , StatsPageState> {
  constructor(props:{}) {
    super(props);
    this.state = {
      balance: 0,
      wru: 0,
      rru: 0,
      elapsed: 0
    }
  }

  componentDidMount(): void {
    let cookie = Server.user.getCookie('dollars-spent');
    let balance = cookie ? (+cookie * -1) : 0;

    let wru = 0;
    let rru = 0;
    let elapsed = 0;

    let st = window.localStorage.getItem('ServiceTracking');
    let serviceTracking:any = st ? JSON.parse(st) : null;

    if(serviceTracking) {
      wru = serviceTracking.wru;
      rru = serviceTracking.rru;
      let now = new Date();
      let then = new Date(serviceTracking.start);
      elapsed = (now.getTime() - then.getTime()) / 1000 / 60;
    }

    this.setState({balance, wru, rru, elapsed});
  }

  onResetDatabase() {
    window.localStorage.removeItem('ServiceTracking');
    this.setState({wru: 0, rru: 0});
  }

  onResetCreditCard() {
    Server.user.setCookie({key: 'dollars-spent', value: '0'});
    this.setState({balance: 0});
  }

  render() {
    if(!Server.account.isLoggedIn())
      return(<Navigate replace to="/" />);

    let ccb = this.state.balance.toFixed(2);
    if(ccb.substring(0, 1) == '-')
      ccb = '-$' + ccb.substring(1);
    else
      ccb = '$' + ccb;

    let rrucost = (this.state.rru / 1000000) * 0.25;
    let wrucost = (this.state.wru / 1000000) * 1.25;
    let dbcost = (rrucost + wrucost);

    let hoursElapsed = this.state.elapsed / 60;
    let days = Math.floor(hoursElapsed / 24);
    hoursElapsed -= (days * 24);
    let hours = Math.floor(hoursElapsed);
    hoursElapsed -= hours;
    let minutes = Math.floor(hoursElapsed * 60);
    let costPerMonth = (dbcost / (this.state.elapsed / 60)) * 24 * 30;

    return (
      <div className="site-page">
        <PageEnvelope width="500px">
          <div className="site-page-panel">
            <div className="site-page-row" style={{justifyContent: 'space-between'}}>
              <div>Database Reads</div>
              <div style={{textAlign: 'right'}}>{this.state.rru}</div>
            </div>

            <div className="site-page-row" style={{justifyContent: 'space-between'}}>
              <div>Database Writes</div>
              <div style={{textAlign: 'right'}}>{this.state.wru}</div>
            </div>

            <div className="site-page-row" style={{justifyContent: 'space-between'}}>
              <div>Database Cost</div>
              <div style={{textAlign: 'right'}}>${dbcost.toFixed(8)}</div>
            </div>

            <div className="site-page-row" style={{justifyContent: 'space-between'}}>
              <div>Tracking Duration</div>
              <div style={{textAlign: 'right'}}>{days}d {hours}h {minutes}m</div>
            </div>

            <div className="site-page-row" style={{justifyContent: 'space-between'}}>
              <div>Monthly Cost Estimate</div>
              <div style={{textAlign: 'right'}}>${costPerMonth.toFixed(4)}</div>
            </div>

            <div className="site-page-row" style={{justifyContent: 'space-between'}}>
              <div>1000 MAU Estimate</div>
              <div style={{textAlign: 'right'}}>${(costPerMonth * 1000).toFixed(2)}</div>
            </div>
          
            <div style={{textAlign: 'center', marginTop: '5px'}}>
              <button onClick={()=>this.onResetDatabase()}>Reset Database Tracking</button>
            </div>
          </div>
        </PageEnvelope>
      </div>
    )
  }
}

export default StatsPage;